import { savePDF } from '@progress/kendo-react-pdf';
import { buildExportFileName } from 'utils';

export const exportPDF = (id = 'reportPDF') => {

    const element = document.getElementById(id) as HTMLElement;
    savePDF(element, {
        fileName: buildExportFileName('Report', 'GroupActivity', 'pdf'),
        margin: 40,
        paperSize: 'auto'
    });

};